import React from 'react'
import { PositionCell } from '../../../../shared/ui/cells/PositionCell'

interface LastPositionCellProps {
  position?: number
  previous_position: number | null
}

export const LastPositionCell = ({ position, previous_position }: LastPositionCellProps) => {
  if (!position && !previous_position) {
    return (
      <div className='flex h-6 items-center'>
        <span className='block h-2 w-2 rounded-full bg-[#D9D9D9]'></span>
      </div>
    )
  }

  if (!position && previous_position) {
    return <span className={'text-danger'}>Lost</span>
  }

  const current = +position!.toFixed(1)
  const previous = previous_position !== null && +previous_position.toFixed(1)

  return <PositionCell current={current} previous={previous} />
}
